/**
 * LinkedOption accessibility fixes for the Minus33 storefront.
 *
 * Removes redundant aria-label attributes when the label exactly
 * duplicates the visible text of a LinkedOption product link.
 */

(function linkedOptionAccessibility() {
  'use strict';

  var VERSION = '2026.09.14.1';
  var SELECTOR = 'a.lv-option-item[aria-label]';
  var observer = null;

  var previous = window.__LINKEDOPTION_A11Y__;

  if (previous && previous.version === VERSION) return;

  if (previous && typeof previous.destroy === 'function') {
    previous.destroy();
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function fixLink(link) {
    if (!link || !link.matches(SELECTOR)) return;

    var visibleText = normalizeText(
      link.innerText || link.textContent
    );

    var ariaLabel = normalizeText(
      link.getAttribute('aria-label')
    );

    /*
     * Preserve useful aria-labels. Remove the attribute only when
     * it exactly duplicates the link's visible text.
     */
    if (visibleText && visibleText === ariaLabel) {
      link.removeAttribute('aria-label');
    }
  }

  function processRoot(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) {
      return;
    }

    if (root.nodeType === 1 && root.matches(SELECTOR)) {
      fixLink(root);
    }

    root.querySelectorAll(SELECTOR).forEach(fixLink);
  }

  function start() {
    processRoot(document);

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          fixLink(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          processRoot(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label']
    });

    console.info(
      '[LinkedOption a11y] initialized',
      VERSION
    );
  }

  function destroy() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  window.__LINKEDOPTION_A11Y__ = {
    version: VERSION,
    refresh: function () {
      processRoot(document);
    },
    destroy: destroy
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  }
})();